__turbopack_context__.v({
  "closeButton": "LeadForm-module__MSv2Zq__closeButton",
  "container": "LeadForm-module__MSv2Zq__container",
  "content": "LeadForm-module__MSv2Zq__content",
  "enrichmentHeader": "LeadForm-module__MSv2Zq__enrichmentHeader",
  "field": "LeadForm-module__MSv2Zq__field",
  "fieldGroup": "LeadForm-module__MSv2Zq__fieldGroup",
  "form": "LeadForm-module__MSv2Zq__form",
  "header": "LeadForm-module__MSv2Zq__header",
  "modalFooter": "LeadForm-module__MSv2Zq__modalFooter",
  "noFooter": "LeadForm-module__MSv2Zq__noFooter",
  "outerContainer": "LeadForm-module__MSv2Zq__outerContainer",
  "overlay": "LeadForm-module__MSv2Zq__overlay",
  "reportStatusWrapper": "LeadForm-module__MSv2Zq__reportStatusWrapper",
  "resultHeader": "LeadForm-module__MSv2Zq__resultHeader",
  "statusWrapper": "LeadForm-module__MSv2Zq__statusWrapper",
});
